// extracted by mini-css-extract-plugin
export var details = "_l8-0";
export var inspectorPopover = "_l8-1";